import { render } from "./removeReferencesPopup.vue?vue&type=template&id=b6302bb8&scoped=true"
import script from "./removeReferencesPopup.vue?vue&type=script&lang=js"
export * from "./removeReferencesPopup.vue?vue&type=script&lang=js"

import "./removeReferencesPopup.vue?vue&type=style&index=0&id=b6302bb8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6302bb8"]])

export default __exports__